module.exports = __webpack_public_path__ + "img/ring_g_i_0_null.d8e9c676.png";